<template>
    <div class="d-inline-flex favorite" @click.stop.prevent="setFavorite" v-if="device && device.show_favorite">
        <HeartFilledIcon v-if="device.is_favorite"/>
        <HeartIcon v-else/>
    </div>
</template>

<script>
import HeartIcon from "@/assets/icons/HeartIcon";
import HeartFilledIcon from "@/assets/icons/HeartFilledIcon";

export default {
    name: "DeviceFavorite",
    components: {
        HeartIcon,
        HeartFilledIcon,
    },
    props: {
        device: {
            type: [Array, Object],
            default: null,
        }
    },
    methods: {
        setFavorite() {
            this.$parent.$emit('switch-favorite', this.device);
        },
    },
}
</script>